'use strict';

var _reactTransformCatchErrors2 = require('react-transform-catch-errors');

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _reactTransformCatchErrors3 = _interopRequireDefault(_reactTransformCatchErrors2);

var _react = require('react');

var _redboxReact = require('redbox-react');

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

exports.__esModule = true;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _utils = require('../../utils');

var _reduxModulesSubscribe = require('redux/modules/subscribe');

var subscribeActions = _interopRequireWildcard(_reduxModulesSubscribe);

var _components2 = require('../../components');

var _components = {
  _$SubscribeForm: {
    displayName: 'SubscribeForm'
  }
};

var _reactComponentWrapper = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/SubscribeForm/SubscribeForm.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

var _reactComponentWrapper2 = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/SubscribeForm/SubscribeForm.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

function _wrapComponent(uniqueId) {
  return function (ReactClass) {
    return _reactComponentWrapper2(_reactComponentWrapper(ReactClass, uniqueId), uniqueId);
  };
}

var SubscribeForm = (function (_Component) {
  _inherits(SubscribeForm, _Component);

  function SubscribeForm() {
    _classCallCheck(this, _SubscribeForm);

    _Component.apply(this, arguments);
  }

  SubscribeForm.prototype.componentDidMount = function componentDidMount() {
    var captcha = this.props.captcha;

    if (captcha) {
      this.renderRecaptcha();
    }
  };

  SubscribeForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var hideSubscribe = this.props.hideSubscribe;
    var _refs = this.refs;
    var subscribeForm = _refs.subscribeForm;
    var subscribeInput = _refs.subscribeInput;

    if (!nextProps.subscribed && !nextProps.subscribing && nextProps.subscribeError) {
      var message = nextProps.subscribeError.message;

      this.showMessage(message, 'is-error');
    } else if (nextProps.subscribing) {
      var subscribeButton = this.refs.subscribeButton;

      subscribeButton.disabled = true;
      this.hideMessage();
    } else if (nextProps.subscribed) {
      this.showMessage('Thank you! We promise not to spam.', 'is-success');
      setTimeout(function () {
        hideSubscribe();
        subscribeInput.value = '';
        subscribeForm.classList.remove('is-success');
      }, 2000);
    }
  };

  SubscribeForm.prototype.onSubscribe = function onSubscribe(emailValue) {
    var _props = this.props;
    var subscribeUser = _props.subscribeUser;
    var captcha = _props.captcha;

    var _validateEmail = _utils.validateEmail(emailValue);

    var valid = _validateEmail.valid;
    var error = _validateEmail.error;

    function getRecaptchaResponse() {
      return captcha ? window.grecaptcha.getResponse() : null;
    }

    if (valid) {
      this.hideMessage();
      subscribeUser(emailValue, captcha, getRecaptchaResponse());
    } else {
      this.showMessage(error, 'is-error');
    }
  };

  SubscribeForm.prototype.showMessage = function showMessage(message, className) {
    var _refs2 = this.refs;
    var subscribeForm = _refs2.subscribeForm;
    var subscribeMessage = _refs2.subscribeMessage;
    var subscribeButton = _refs2.subscribeButton;

    subscribeMessage.textContent = message;
    subscribeButton.disabled = false;
    subscribeForm.classList.remove('is-error', 'is-success');
    subscribeForm.classList.add(className);
  };

  SubscribeForm.prototype.hideMessage = function hideMessage() {
    var subscribeForm = this.refs.subscribeForm;

    subscribeForm.classList.remove('is-error', 'is-success');
  };

  SubscribeForm.prototype.renderButtonState = function renderButtonState() {
    var subscribing = this.props.subscribing;

    if (subscribing) {
      return _react2['default'].createElement(_components2.AppLoader, { theme: 'light', size: '25' });
    }

    return _react2['default'].createElement(
      'span',
      { className: 'subscribe-form__subscribe-btn-text' },
      'Subscribe'
    );
  };

  SubscribeForm.prototype.renderRecaptcha = function renderRecaptcha() {
    window.grecaptcha.render(this.refs.subscribeRecaptcha, {
      'sitekey': '6Ld2TBwTAAAAAKR9kVw5iRAJI-lzjaTSvmDisbmZ',
      'theme': 'light'
    });
  };

  SubscribeForm.prototype.render = function render() {
    var _this = this;

    var hideSubscribe = this.props.hideSubscribe;

    var subscribeIcon = require('../../assets/images/subscribe-icon.png');

    return _react2['default'].createElement(
      'form',
      { className: 'subscribe-form', ref: 'subscribeForm', action: '', noValidate: true, onSubmit: function (event) {
          event.preventDefault();
          if (!_this.refs.subscribeButton.disabled) {
            _this.onSubscribe(_this.refs.subscribeInput.value);
          }
        } },
      _react2['default'].createElement(
        'button',
        { className: 'subscribe-form__close-btn', type: 'button', onClick: function () {
            return hideSubscribe();
          } },
        _react2['default'].createElement(
          'svg',
          { className: 'icon icon--close', viewBox: '0 0 36 36' },
          _react2['default'].createElement('use', { xlinkHref: '#icon-close' })
        )
      ),
      _react2['default'].createElement(
        'div',
        { className: 'subscribe-form__content' },
        _react2['default'].createElement('img', { className: 'subscribe-form__img', src: subscribeIcon, width: '160', height: '158' }),
        _react2['default'].createElement(
          'div',
          { className: 'subscribe-form__heading' },
          'Stay up-to-date'
        ),
        _react2['default'].createElement(
          'div',
          { className: 'subscribe-form__description' },
          'Get our news earlier than others.'
        ),
        _react2['default'].createElement(
          'div',
          { className: 'subscribe-form__form-group' },
          _react2['default'].createElement('input', { className: 'subscribe-form__input', ref: 'subscribeInput', type: 'email', placeholder: 'Your email' }),
          _react2['default'].createElement(
            'button',
            { className: 'subscribe-form__subscribe-btn btn btn--tertiary', ref: 'subscribeButton', type: 'submit' },
            this.renderButtonState()
          ),
          _react2['default'].createElement(
            'span',
            { className: 'subscribe-form__message', ref: 'subscribeMessage' },
            'Please enter valid email'
          )
        ),
        _react2['default'].createElement('div', { className: 'subscribe-form__recaptcha g-recaptcha', ref: 'subscribeRecaptcha' })
      )
    );
  };

  _createClass(SubscribeForm, null, [{
    key: 'propTypes',
    value: {
      subscribing: _react.PropTypes.bool,
      subscribed: _react.PropTypes.bool,
      captcha: _react.PropTypes.bool,
      hideSubscribe: _react.PropTypes.func.isRequired,
      subscribeUser: _react.PropTypes.func.isRequired,
      subscribeError: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.object])
    },
    enumerable: true
  }]);

  var _SubscribeForm = SubscribeForm;
  SubscribeForm = _wrapComponent('_$SubscribeForm')(SubscribeForm) || SubscribeForm;
  SubscribeForm = _reactRedux.connect(function (state) {
    return {
      subscribing: state.subscribe.subscribing,
      subscribed: state.subscribe.subscribed,
      subscribeError: state.subscribe.error,
      captcha: state.subscribe.captcha
    };
  }, function (dispatch) {
    return _redux.bindActionCreators(subscribeActions, dispatch);
  })(SubscribeForm) || SubscribeForm;
  return SubscribeForm;
})(_react.Component);

exports['default'] = SubscribeForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SubscribeForm/SubscribeForm.js
// module id = 673
// module chunks = 0